// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"549e09f5ab25b1ddd637","655":"c736d9febaa371cbf8ce"}[chunkId] + ".js";
};